function LoaderDisplay() {
  return <div className='lds-dual-ring'></div>;
}

export default LoaderDisplay;
